const guiColors = {
    'motion-primary': '#59C059',
    'motion-primary-transparent': '#59C059e6',
    'motion-tertiary': '#389438',
    'looks-secondary': '#59C059',
    'looks-transparent': '#59C05959',
    'looks-light-transparent': '#59C05926',
    'looks-secondary-dark': 'hsla(120, 42%, 51%, 1)',
    'extensions-primary': '#389438',
    'extensions-tertiary': '#2e742e',
    'extensions-transparent': 'hsla(120, 100%, 30%, 0.35)',
    'extensions-light': '#4a9a4a',
    'drop-highlight': '#66bb6a',
    'turbowarp-color': '#ff4c4c',
    'turbowarp-transparent': '#ff4c4c26',
};

const blockColors = {
    checkboxActiveBackground: '#59C059',
    checkboxActiveBorder: '#389438'
};

export {
    guiColors,
    blockColors
};
